export default function () {
    return {
        "Let’s Get Started": {
            "fr": "Commencer",
            "en": "Let’s Get Started"
        },
        "Accept credit cards in your store, on the go, or online.": {
            "fr": "Acceptez les cartes de crédit dans votre magasin, en déplacement ou en ligne.",
            "en": "Accept credit cards in your store, on the go, or online."
        },
        "Yes": {
            "fr": "Oui",
            "en": "Yes"
        },
        "No": {
            "fr": "Non",
            "en": "No"
        },
        "Do you accept credit cards now?": {
            "fr": "Acceptez-vous déjà les cartes de crédit ?",
            "en": "Do you accept credit cards now?"
        },
        "Credit cards" : {
            "fr": "Cartes de crédit",
            "en": "Credit cards"
        },
        "Back": {
            "fr": "Retour",
            "en": "Back"
        },
        "Next": {
            "fr": "Suivant",
            "en": "Next"
        },
        "Step": {
            "fr": "Étape",
            "en": "Step"
        },
        "of": {
            "fr": "de",
            "en": "of"
        },
        "Processing method": {
            "fr": "Méthode de traitement",
            "en": "Processing method"
        },
        "Choose your processing method": {
            "fr": "Choisissez votre méthode de traitement",
            "en": "Choose your processing method"
        },
        "Counter top Credit Card Terminal": {
            "fr": "Terminal de paiement fixe",
            "en": "Counter top Credit Card Terminal"
        },
        "Wireless Credit Card Terminal": {
            "fr": "Terminal de paiement sans fil",
            "en": "Wireless Credit Card Terminal"
        },
        "Online Processing": {
            "fr": "Traitement en ligne",
            "en": "Online Processing"
        },
        "Tell Us About You": {
            "fr": "Parlez-nous de vous",
            "en": "Tell Us About You"
        },
        "Name": {
            "fr": "Nom",
            "en": "Name"
        },
        "First name": {
            "fr": "Prénom",
            "en": "First name"
        },
        "Last name": {
            "fr": "Nom de famille",
            "en": "Last name"
        },
        "Email": {
            "fr": "Courriel",
            "en": "Email"
        },
        "Phone": {
            "fr": "Téléphone",
            "en": "Phone"
        },
        "Company Name": {
            "fr": "Nom de l'entreprise",
            "en": "Business Name"
        },
        "Company location": {
            "fr": "Emplacement de l'entreprise",
            "en": "Company location"
        },
        "Monthly Volume": {
            "fr": "Volume mensuel estimé",
            "en": "Monthly Volume"
        },
        "How soon do you need to get started?": {
            "fr": "Dans quel délai souhaitez-vous commencer ?",
            "en": "How soon do you need to get started?"
        },
        "USA": {
            "fr": "États-Unis",
            "en": "USA"
        },
        "Less than $50 000": {
            "fr": "Moins de 50 000 $",
            "en": "Less than $50 000"
        },
        "$50 000 to $200 000": {
            "fr": "50 000 $ à 200 000 $",
            "en": "$50 000 to $200 000"
        },
        "$200 001 to $500 000": {
            "fr": "200 001 $ à 500 000 $",
            "en": "$200 001 to $500 000"
        },
        "$500 001 to $1 000 000": {
            "fr": "500 001 $ à 1 000 000 $",
            "en": "$500 001 to $1 000 000"
        },
        "$1 000 001 to $2 500 000": {
            "fr": "1 000 001 $ à 2 500 000 $",
            "en": "$1 000 001 to $2 500 000"
        },
        "$2 500 001 to $5 000 000": {
            "fr": "2 500 001 $ à 5 000 000 $",
            "en": "$2 500 001 to $5 000 000"
        },
        "$5 000 001 +": {
            "fr": "5 000 001 $ +",
            "en": "$5 000 001 +"
        },
        "Enter a value for this field": {
            "fr": "Entrez une valeur pour ce champ",
            "en": "Enter a value for this field"
        },
        "This field is invalid": {
            "fr": "Ce champ est invalide",
            "en": "This field is invalid"
        },
        "You must select at least one option.": {
            "fr": "Vous devez sélectionner au moins une option.",
            "en": "You must select at least one option."
        },
        "How soon do you need to get started" : {
            "fr": "Dans quel délai souhaitez-vous commencer",
            "en": "How soon do you need to get started"
        },
        "Get Solution": {
            "fr": "Obtenir une solution",
            "en": "Get Solution"
        },
        "Less than a week": {
            "fr": "Moins d'une semaine",
            "en": "Less than a week"
        },
        "1-2 Weeks": {
            "fr": "1-2 semaines",
            "en": "1-2 Weeks"
        },
        "3-6 Weeks": {
            "fr": "3-6 semaines",
            "en": "3-6 Weeks"
        },
        "7+ Weeks": {
            "fr": "7+ semaines",
            "en": "7+ Weeks"
        },
        "Thank you": {
            "fr": "Merci",
            "en": "Thank you"
        },
        "Your information has been submitted.": {
            "fr": "Vos informations ont été soumises.",
            "en": "Your information has been submitted."
        },
        "We will be in touch shortly.": {
            "fr": "Nous vous contacterons sous peu.",
            "en": "We will be in touch shortly."
        },
        "Partnerships inquiry": {
            "fr": "Demande de partenariat",
            "en": "Partnerships inquiry"
        },
        "Partner Type": {
            "fr": "Type de partenaire",
            "en": "Partner Type"
        },
        "Tell us about your organization, and what you like to achieve with PandaPay": {
            "fr": "Parlez-nous de votre organisation et de ce que vous souhaitez réaliser avec PandaPay.",
            "en": "Tell us about your organization, and what you like to achieve with PandaPay."
        },
        "Submit": {
            "fr": "Soumettre",
            "en": "Submit"
        },
        "Country": {
            "fr": "Pays",
            "en": "Country"
        },
        "Enter a value for this field.": {
            "fr": "Entrez une valeur pour ce champ.",
            "en": "Enter a value for this field."
        },
    }
}